<template>
  <v-card>
    <div class="ml-4 mt-4 subtitile-1">
      <span style="color: red">*</span>
      {{ $t("poll.ruleRequired") }}
    </div>
    <template v-for="(question, index) in questionsDetails">
      <div :key="index">
        <v-card-title>
          {{ question.question
          }}<span v-if="question.isMandatory" style="color: red" class="ml-1"
            >*</span
          >
        </v-card-title>
        <v-card-subtitle class="ml-1 pt-2" v-if="question.isSubtitle">{{
          question.subtitle
        }}</v-card-subtitle>
        <v-card-text>
          <v-form ref="refPollQuestionForm" v-model="valid" lazy-validation>
            <v-list dense>
              <v-input
                :value="question.selectedAnswer"
                :rules="question.isMandatory ? [requiredRules] : []"
              >
                <v-list-item-group
                  :multiple="question.isMultipleAnswer"
                  color="indigo"
                  v-model="question.selectedAnswer"
                  style="width: 100%"
                >
                  <check-box-choice
                    v-if="question.isMultipleAnswer"
                    :question="question"
                    :isReadOnly="isReadOnly"
                  >
                  </check-box-choice>
                  <radio-button-choice
                    v-else
                    :question="question"
                    :isReadOnly="isReadOnly"
                  ></radio-button-choice>
                  <!-- <v-radio-group v-model="question.selectedAnswer">
                <v-list-item
                  v-for="(option, i) in question.options"
                  :key="i"
                  class="group-item-list"
                  @click="onItemClick(option, question)"
                  :value="option.value"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content class="font-weight-medium">
                      <v-layout>
                        <v-row align="center">
                          <v-col cols="1">
                            <v-row no-gutters justify="start">
                              <v-checkbox
                                v-if="question.isMultipleAnswer"
                                :input-value="active"
                                hide-details
                                dense
                                class="pa-0 ma-0 pl-1"
                              >
                              </v-checkbox>
                              <v-radio
                                v-else
                                :value="option.value"
                                dense
                                class="pa-0 ma-0 pl-1"
                              ></v-radio>
                            </v-row>
                          </v-col>
                          <v-col cols="8" class="px-0">
                            <v-row no-gutters justify="start"
                              ><span class="expire-label"
                                >{{ option.text }}
                              </span></v-row
                            >
                          </v-col>
                          <v-col cols="3" class="px-0" justify="end">
                            <v-row no-gutters justify="center">
                              <v-col
                                cols="3"
                                class="d-flex justify-center align-center"
                              >
                                <span class="vote-label">
                                  8 Peoples
                                </span>
                              </v-col>
                              <v-col cols="9" class="pl-3">
                                <avatar-group></avatar-group>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-radio-group> -->
                </v-list-item-group>
              </v-input>
            </v-list>
          </v-form>
        </v-card-text>
      </div>
    </template>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              shaped
              class="ma-3"
              color="primaryDark"
              small
              dark
              v-if="!isReadOnly"
              @click="onSubmitSurvey"
              v-bind="attrs"
                      v-on="on"
              >{{ $t("poll.btnSubmit") }}
            </a-btn>
          </template>
                <span>{{ $t("poll.btnSubmit") }} </span>
        </v-tooltip>
    </v-card-actions>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import AvatarGroup from "./AvatarGroup.vue";
import { createUUID } from "../../utils/util";
import CheckBoxChoice from "./CheckBoxChoice.vue";
import RadioButtonChoice from "./RadioButtonChoice.vue";
import MessageSheet from "../MessageSheet.vue";

export default {
  name: "PollQuestion",
  components: { AvatarGroup, CheckBoxChoice, RadioButtonChoice, MessageSheet },
  props: {
    surveyQuestions: {
      type: [Object, Array],
    },
    answer: {
      type: [Number, String, Array, Object],
    },

    isReadOnly: { type: Boolean, default: false },
  },
  computed: {
    questionsDetails() {
      return this.surveyQuestions ? this.surveyQuestions.questions : [];
    },
  },
  data() {
    return {
      valid: true,
      selectedItem: null,
      selected: [],
      isMultiple: true,
      model: null,
      displayMessage: false,
      messageType: "",
      message: "",
      items: [
        {
          text: "Java Script",
          voteCount: 1,
        },
        {
          text: "Python",
          voteCount: 3,
        },
        {
          text: "C#",
          voteCount: 6,
        },
        {
          text: "Java",
          voteCount: 7,
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      submitSurveyResult: "poll/submitSurveyResult",
    }),
    onItemClick,
    onSubmitSurvey,
    createUUID,
    requiredRules,
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  },
};

function requiredRules(value) {
  return (!!value && value.length > 0) || this.$t("poll.ruleSelectOneItem");
}

function onSubmitSurvey() {
  let isFormValid = true;
  this.$refs.refPollQuestionForm.forEach(async (form) => {
    if (!form.validate()) {
      isFormValid = false;
    }
  });
  if (isFormValid) {
    const answer = _.cloneDeep(
      this.surveyQuestions.questions.map((x) => {
        return {
          answer: x.selectedAnswer,
          questionId: x.id,
        };
      })
    );
    const finalResult = {
      id: createUUID(),
      surveyid: this.surveyQuestions.id,
      userid: this.$auth.user.email,
      userName: this.$auth.user.tenantUserName,
      tenantid: sessionStorage.getItem("tenantId"),
      submitDate: new Date().toISOString(),
      questionAnswers: answer,
    };

    this.submitSurveyResult(finalResult);
    this.surveyQuestions.user_responded = true
    this.showMessageSheet(this.$t("poll.msgPollSubmissionSuccess"), "success");
  }
}

function onItemClick(item, question) {
  //   item.voteCount++;
  //   this.selectedItem = item;
  //   question.selectedAnswer = item;
  // const indexOfObject = this.selected.findIndex((object) => {
  //   return (
  //     String(object.text).toLowerCase() === String(item.text).toLowerCase()
  //   );
  // });
  // if (indexOfObject > -1) {
  //   this.selected.splice(indexOfObject, 1);
  // } else {
  //   this.selected.push(item);
  // }
  // // this.$emit("update", this.selected);
  // question.selectedAnswer = this.selected;
  // item.isSelected = !item.isSelected;
}
</script>

<style scoped>
.border {
  border: 1px solid gray;
}
.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}
</style>